module.exports = __webpack_public_path__ + "static/media/SettingsActive.3d30e47b.svg";